const translations = {
  pt: {
    header: {
      logo: 'ECOFAB',
      nav: ['Soluções', 'Como Funciona', 'Blog', 'Responsabilidade', 'Contato'],
    },
    hero: {
      headline: 'Tecnologia para um Futuro Mais Verde',
      subheadline: 'A ECOFAB desenvolve, produz e comercializa equipamentos e soluções ambientais com tecnologia de ponta para o tratamento e destinação definitiva adequada aos resíduos, visando o Carbono Neutro e Lixo Zero.',
      cta: 'Fale com um Especialista',
      recyclingIconLabel: 'Índice de resíduos reciclados',
    },
    howItWorks: {
      title: 'Como Funciona a Usina Cidade Limpa da ECOFAB',
      steps: [
        {
          title: 'Reciclagem e Reutilização',
          description:
            'Processo de separação e aproveitamento de tudo aquilo que pode ser reaproveitado e reutilizado para diminuir o uso de matéria-prima, realizado por equipe especializada com suporte de tecnologia avançada.',
          imageLabel: 'Processo de reciclagem',
        },
        {
          title: 'Compostagem Assistida',
          description:
            'Os resíduos orgânicos são direcionados às baias de compostagem, onde passam por um processo controlado de 20 a 30 dias para produção de adubo orgânico de alta qualidade, seguindo todas as regulamentações.',
          imageLabel: 'Baias de compostagem',
        },
        {
          title: 'Combustão de Rejeitos com MAQ-RSU',
          description:
            'Sistema automatizado que realiza a combustão completa dos rejeitos não reaproveitáveis a 850°C, com 6 níveis de tratamento de gases e aproveitamento das cinzas para produção de pavers e tijolos ecológicos.',
          imageLabel: 'Sistema MAQ-RSU',
        },
        {
          title: 'Produção de Materiais Sustentáveis',
          description:
            'As cinzas do processo são transformadas em pavers e tijolos ecológicos, que podem ser utilizados em obras públicas locais como calçadas, praças e pavimentação, gerando benefício direto para a comunidade.',
          imageLabel: 'Produtos sustentáveis',
        },
        {
          title: 'Interface Social e Educação Ambiental',
          description:
            'Programa completo de interação social com ações online e offline, incluindo parcerias com poder público, instituições de ensino e empresas locais para educação ambiental e conscientização.',
          imageLabel: 'Ações sociais',
        },
      ],
      extraInfo: 'Nossa tecnologia reduz até 95% do volume dos resíduos, com operação automatizada e baixo consumo de combustível fóssil.',
    },
    solutions: {
      title: 'Soluções',
      cards: [
        {
          title: 'MAQ-RSU',
          imageLabel: 'Sistema MAQ-RSU',
          summary: 'Sistema automatizado para tratamento térmico de rejeitos com tecnologia verde própria e monitoramento remoto.',
          differentials: [
            'Redução de até 95% do volume de resíduos',
            '6 níveis de tratamento de gases',
            'Operação automatizada com controle local e remoto',
          ],
          button: 'Saiba Mais',
        },
        {
          title: 'Usina Cidade Limpa',
          imageLabel: 'Usina Cidade Limpa',
          summary: 'Solução completa para tratamento de resíduos urbanos com foco em reciclagem, compostagem e geração de valor.',
          differentials: [
            'Aumento de 500% em empregos formais',
            'Produção de materiais sustentáveis',
            'Impacto social positivo',
          ],
          button: 'Saiba Mais',
        },
      ],
    },
    cases: {
      title: 'Casos de Sucesso',
      cards: [
        {
          name: 'Prefeitura Municipal',
          testimonial: 'A ECOFAB transformou nossa gestão de resíduos com tecnologia e responsabilidade social.',
          impact: 'Redução significativa no uso de aterros',
          logoLabel: 'Logo Prefeitura',
        },
        {
          name: 'Consórcio Municipal',
          testimonial: 'Solução completa que atende todas as regulamentações ambientais com resultados expressivos.',
          impact: 'Aumento na geração de empregos formais',
          logoLabel: 'Logo Consórcio',
        },
        {
          name: 'Cooperativa Local',
          testimonial: 'A parceria com a ECOFAB trouxe dignidade e renda para nossa comunidade.',
          impact: 'Produção de materiais para obras públicas',
          logoLabel: 'Logo Cooperativa',
        },
      ],
      button: 'Ver mais cases',
    },
    blog: {
      title: 'Blog',
      articles: [
        {
          title: 'Brasileiro descarta 382 kg de lixo por ano',
          teaser: 'Estudo revela o impacto do descarte de resíduos por habitante no meio ambiente e destaca a importância da gestão adequada.',
          date: '4 de Abril, 2025',
          category: 'Meio Ambiente',
          imageLabel: 'Descarte de Resíduos',
          image: require('./assets/images/blog-1.jpeg'),
          button: 'Ler artigo completo',
          url: 'https://agenciabrasil.ebc.com.br/radioagencia-nacional/meio-ambiente/audio/2025-04/cada-brasileiro-descarta-por-ano-382-kg-de-lixo-no-meio-ambiente'
        },
        {
          title: 'Nova Lei de Educação Ambiental nas Escolas',
          teaser: 'Projeto de lei propõe atualização nas diretrizes de educação ambiental para escolas brasileiras.',
          date: '15 de Março, 2025',
          category: 'Educação',
          imageLabel: 'Educação Ambiental',
          image: require('./assets/images/cenario-colaboracao-sust.png'),
          button: 'Ler artigo completo',
          url: 'https://www.camara.leg.br/noticias/1141175-projeto-cria-nova-lei-sobre-educacao-ambiental-nas-escolas'
        },
        {
          title: 'Nova Resolução CONAMA sobre Emissões',
          teaser: 'CONAMA propõe nova resolução sobre emissão de ASV para UAS, impactando o setor ambiental.',
          date: '22 de Março, 2025',
          category: 'Legislação',
          imageLabel: 'CONAMA',
          image: require('./assets/images/blog-3.jpeg'),
          button: 'Ler artigo completo',
          url: 'https://www.conjur.com.br/2025-mar-22/nova-proposta-de-resolucao-do-conama-sobre-emissao-de-asv-uas-e-cai/'
        },
      ],
    },
    esg: {
      title: 'Responsabilidade Socioambiental',
      text: 'Fundada em 2020, a ECOFAB conta com equipes multidisciplinares compostas por gestores, economistas, engenheiros (mecânicos, computação, químicos, civil, segurança do trabalho e elétrico), arquitetos, projetistas e consultores ambientais. Nosso compromisso com ESG (Environmental, Social and Governance) se reflete em valores como comprometimento, agilidade, integridade, inovação tecnológica, formação continuada, ética, responsabilidade, sustentabilidade e valorização da vida.',
      icons: ['Sustentável', 'ISO', 'Social', 'ESG'],
    },
    contact: {
      title: 'Contato',
      placeholders: {
        name: 'Nome',
        email: 'E-mail',
        company: 'Empresa',
        message: 'Mensagem',
      },
      button: 'Enviar',
      successMessage: 'Mensagem enviada com sucesso!',
      errorMessage: 'Erro ao enviar mensagem. Por favor, tente novamente.',
    },
    footer: {
      quickLinks: 'Links Rápidos',
      links: ['Soluções', 'Como Funciona', 'Blog', 'Responsabilidade', 'Contato'],
      contactTitle: 'Contato ECOFAB',
      address: 'Rua Nakle Francisco 1115\nBairro - Centro\nCidade - Balneário de Piçarras\nEstado - SC\nTelefone: (47) 9 3300-3006\nEmail: contato@ecofab.com.br',
      downloads: ['Catálogo de Produtos (PDF)', 'Ficha Técnica (PDF)'],
      socialTitle: 'Redes Sociais',
      credits: '© 2024 ECOFAB Equipamentos e Soluções Sustentáveis LTDA - Todos os direitos reservados.',
    },
  },
  en: {
    header: {
      logo: 'ECOFAB',
      nav: ['Solutions', 'How It Works', 'Blog', 'Responsibility', 'Contact'],
    },
    hero: {
      headline: 'Technology for a Greener Future',
      subheadline: 'ECOFAB develops, produces and markets environmental equipment and solutions with cutting-edge technology for proper treatment and final disposal of waste, aiming for Carbon Neutral and Zero Waste.',
      cta: 'Talk to a Specialist',
      recyclingIconLabel: 'Recycling rate',
    },
    howItWorks: {
      title: 'How the ECOFAB Clean City Plant Works',
      steps: [
        {
          title: 'Recycling and Reuse',
          description:
            'Process of separating and utilizing everything that can be reused to reduce raw material usage, carried out by specialized team with advanced technology support.',
          imageLabel: 'Recycling process',
        },
        {
          title: 'Assisted Composting',
          description:
            'Organic waste is directed to composting bays, where it undergoes a controlled 20-30 day process to produce high-quality organic fertilizer, following all regulations.',
          imageLabel: 'Composting bays',
        },
        {
          title: 'Waste Combustion with MAQ-RSU',
          description:
            'Automated system that performs complete combustion of non-reusable waste at 850°C, with 6 levels of gas treatment and use of ashes for production of eco-friendly pavers and bricks.',
          imageLabel: 'MAQ-RSU System',
        },
        {
          title: 'Sustainable Materials Production',
          description:
            'Process ashes are transformed into eco-friendly pavers and bricks that can be used in local public works such as sidewalks, squares, and paving, generating direct benefit for the community.',
          imageLabel: 'Sustainable products',
        },
        {
          title: 'Social Interface and Environmental Education',
          description:
            'Complete social interaction program with online and offline actions, including partnerships with public authorities, educational institutions, and local companies for environmental education and awareness.',
          imageLabel: 'Social actions',
        },
      ],
      extraInfo: 'Our technology reduces waste volume by up to 95%, with automated operation and low fossil fuel consumption.',
    },
    solutions: {
      title: 'Solutions',
      cards: [
        {
          title: 'MAQ-RSU',
          imageLabel: 'MAQ-RSU System',
          summary: 'Automated system for thermal treatment of waste with proprietary green technology and remote monitoring.',
          differentials: [
            'Up to 95% waste volume reduction',
            '6 levels of gas treatment',
            'Automated operation with local and remote control',
          ],
          button: 'Learn More',
        },
        {
          title: 'Clean City Plant',
          imageLabel: 'Clean City Plant',
          summary: 'Complete solution for urban waste treatment focusing on recycling, composting, and value generation.',
          differentials: [
            '500% increase in formal jobs',
            'Sustainable materials production',
            'Positive social impact',
          ],
          button: 'Learn More',
        },
      ],
    },
    cases: {
      title: 'Success Stories',
      cards: [
        {
          name: 'City Hall',
          testimonial: 'ECOFAB transformed our waste management with technology and social responsibility.',
          impact: 'Significant reduction in landfill use',
          logoLabel: 'City Hall Logo',
        },
        {
          name: 'Municipal Consortium',
          testimonial: 'Complete solution that meets all environmental regulations with expressive results.',
          impact: 'Increase in formal job generation',
          logoLabel: 'Consortium Logo',
        },
        {
          name: 'Local Cooperative',
          testimonial: 'Partnership with ECOFAB brought dignity and income to our community.',
          impact: 'Production of materials for public works',
          logoLabel: 'Cooperative Logo',
        },
      ],
      button: 'See more cases',
    },
    blog: {
      title: 'Blog',
      articles: [
        {
          title: 'Brazilians Discard 382 kg of Waste per Year',
          teaser: 'Study reveals the impact of waste disposal per inhabitant on the environment and highlights the importance of proper management.',
          date: 'April 4, 2025',
          category: 'Environment',
          imageLabel: 'Waste Disposal',
          image: require('./assets/images/blog-1.jpeg'),
          button: 'Read full article',
          url: 'https://agenciabrasil.ebc.com.br/radioagencia-nacional/meio-ambiente/audio/2025-04/cada-brasileiro-descarta-por-ano-382-kg-de-lixo-no-meio-ambiente'
        },
        {
          title: 'New Environmental Education Law in Schools',
          teaser: 'Bill proposes update to environmental education guidelines for Brazilian schools.',
          date: 'March 15, 2025',
          category: 'Education',
          imageLabel: 'Environmental Education',
          image: require('./assets/images/cenario-colaboracao-sust.png'),
          button: 'Read full article',
          url: 'https://www.camara.leg.br/noticias/1141175-projeto-cria-nova-lei-sobre-educacao-ambiental-nas-escolas'
        },
        {
          title: 'New CONAMA Resolution on Emissions',
          teaser: 'CONAMA proposes new resolution on ASV emission for UAS, impacting the environmental sector.',
          date: 'March 22, 2025',
          category: 'Legislation',
          imageLabel: 'CONAMA',
          image: require('./assets/images/blog-3.jpeg'),
          button: 'Read full article',
          url: 'https://www.conjur.com.br/2025-mar-22/nova-proposta-de-resolucao-do-conama-sobre-emissao-de-asv-uas-e-cai/'
        },
      ],
    },
    esg: {
      title: 'Social and Environmental Responsibility',
      text: 'Founded in 2020, ECOFAB has multidisciplinary teams composed of managers, economists, engineers (mechanical, computing, chemical, civil, work safety, and electrical), architects, designers, and environmental consultants. Our commitment to ESG (Environmental, Social and Governance) is reflected in values such as commitment, agility, integrity, technological innovation, continuous training, ethics, responsibility, sustainability, and appreciation of life.',
      icons: ['Sustainable', 'ISO', 'Social', 'ESG'],
    },
    contact: {
      title: 'Contact',
      placeholders: {
        name: 'Name',
        email: 'Email',
        company: 'Company',
        message: 'Message',
      },
      button: 'Send',
      successMessage: 'Message sent successfully!',
      errorMessage: 'Error sending message. Please try again.',
    },
    footer: {
      quickLinks: 'Quick Links',
      links: ['Solutions', 'How It Works', 'Blog', 'Responsibility', 'Contact'],
      contactTitle: 'ECOFAB Contact',
      address: 'Rua Nakle Francisco 1115\nBairro - Centro\nCidade - Balneário de Piçarras\nEstado - SC\nPhone: (47) 9 3300-3006\nEmail: contato@ecofab.com.br',
      downloads: ['Product Catalog (PDF)', 'Technical Sheet (PDF)'],
      socialTitle: 'Social Networks',
      credits: '© 2024 ECOFAB Sustainable Equipment and Solutions LTDA - All rights reserved.',
    },
  },
  es: {
    header: {
      logo: 'ECOFAB',
      nav: ['Soluciones', 'Cómo Funciona', 'Blog', 'Responsabilidad', 'Contacto'],
    },
    hero: {
      headline: 'Tecnología para un Futuro Más Verde',
      subheadline: 'ECOFAB desarrolla, produce y comercializa equipos y soluciones ambientales con tecnología de punta para el tratamiento y disposición final adecuada de residuos, apuntando al Carbono Neutro y Cero Residuos.',
      cta: 'Habla con un Especialista',
      recyclingIconLabel: 'Índice de residuos reciclados',
    },
    howItWorks: {
      title: 'Cómo Funciona la Planta Ciudad Limpia de ECOFAB',
      steps: [
        {
          title: 'Reciclaje y Reutilización',
          description:
            'Proceso de separación y aprovechamiento de todo lo que puede ser reutilizado para reducir el uso de materia prima, realizado por equipo especializado con soporte de tecnología avanzada.',
          imageLabel: 'Proceso de reciclaje',
        },
        {
          title: 'Compostaje Asistido',
          description:
            'Los residuos orgánicos se dirigen a las bahías de compostaje, donde pasan por un proceso controlado de 20 a 30 días para producir abono orgánico de alta calidad, siguiendo todas las regulaciones.',
          imageLabel: 'Bahías de compostaje',
        },
        {
          title: 'Combustión de Rechazos con MAQ-RSU',
          description:
            'Sistema automatizado que realiza la combustión completa de los rechazos no reutilizables a 850°C, con 6 niveles de tratamiento de gases y aprovechamiento de las cenizas para producción de adoquines y ladrillos ecológicos.',
          imageLabel: 'Sistema MAQ-RSU',
        },
        {
          title: 'Producción de Materiales Sostenibles',
          description:
            'Las cenizas del proceso se transforman en adoquines y ladrillos ecológicos que pueden utilizarse en obras públicas locales como aceras, plazas y pavimentación, generando beneficio directo para la comunidad.',
          imageLabel: 'Productos sostenibles',
        },
        {
          title: 'Interfaz Social y Educación Ambiental',
          description:
            'Programa completo de interacción social con acciones online y offline, incluyendo alianzas con poder público, instituciones educativas y empresas locales para educación ambiental y concientización.',
          imageLabel: 'Acciones sociales',
        },
      ],
      extraInfo: 'Nuestra tecnología reduce hasta el 95% del volumen de residuos, con operación automatizada y bajo consumo de combustible fósil.',
    },
    solutions: {
      title: 'Soluciones',
      cards: [
        {
          title: 'MAQ-RSU',
          imageLabel: 'Sistema MAQ-RSU',
          summary: 'Sistema automatizado para tratamiento térmico de rechazos con tecnología verde propia y monitoreo remoto.',
          differentials: [
            'Reducción de hasta 95% del volumen de residuos',
            '6 niveles de tratamiento de gases',
            'Operación automatizada con control local y remoto',
          ],
          button: 'Saber Más',
        },
        {
          title: 'Planta Ciudad Limpia',
          imageLabel: 'Planta Ciudad Limpia',
          summary: 'Solución completa para tratamiento de residuos urbanos con foco en reciclaje, compostaje y generación de valor.',
          differentials: [
            'Aumento del 500% en empleos formales',
            'Producción de materiales sostenibles',
            'Impacto social positivo',
          ],
          button: 'Saber Más',
        },
      ],
    },
    cases: {
      title: 'Casos de Éxito',
      cards: [
        {
          name: 'Ayuntamiento Municipal',
          testimonial: 'ECOFAB transformó nuestra gestión de residuos con tecnología y responsabilidad social.',
          impact: 'Reducción significativa en uso de vertederos',
          logoLabel: 'Logo Ayuntamiento',
        },
        {
          name: 'Consorcio Municipal',
          testimonial: 'Solución completa que cumple todas las regulaciones ambientales con resultados expresivos.',
          impact: 'Aumento en la generación de empleos formales',
          logoLabel: 'Logo Consorcio',
        },
        {
          name: 'Cooperativa Local',
          testimonial: 'La asociación con ECOFAB trajo dignidad e ingresos a nuestra comunidad.',
          impact: 'Producción de materiales para obras públicas',
          logoLabel: 'Logo Cooperativa',
        },
      ],
      button: 'Ver más casos',
    },
    blog: {
      title: 'Blog',
      articles: [
        {
          title: 'Brasileños Descartan 382 kg de Residuos por Año',
          teaser: 'Estudio revela el impacto del descarte de residuos por habitante en el medio ambiente y destaca la importancia de una gestión adecuada.',
          date: '4 de Abril, 2025',
          category: 'Medio Ambiente',
          imageLabel: 'Descarte de Residuos',
          image: require('./assets/images/blog-1.jpeg'),
          button: 'Leer artículo completo',
          url: 'https://agenciabrasil.ebc.com.br/radioagencia-nacional/meio-ambiente/audio/2025-04/cada-brasileiro-descarta-por-ano-382-kg-de-lixo-no-meio-ambiente'
        },
        {
          title: 'Nueva Ley de Educación Ambiental en Escuelas',
          teaser: 'Proyecto de ley propone actualización en las directrices de educación ambiental para escuelas brasileñas.',
          date: '15 de Marzo, 2025',
          category: 'Educación',
          imageLabel: 'Educación Ambiental',
          image: require('./assets/images/cenario-colaboracao-sust.png'),
          button: 'Leer artículo completo',
          url: 'https://www.camara.leg.br/noticias/1141175-projeto-cria-nova-lei-sobre-educacao-ambiental-nas-escolas'
        },
        {
          title: 'Nueva Resolución CONAMA sobre Emisiones',
          teaser: 'CONAMA propone nueva resolución sobre emisión de ASV para UAS, impactando el sector ambiental.',
          date: '22 de Marzo, 2025',
          category: 'Legislación',
          imageLabel: 'CONAMA',
          image: require('./assets/images/blog-3.jpeg'),
          button: 'Leer artículo completo',
          url: 'https://www.conjur.com.br/2025-mar-22/nova-proposta-de-resolucao-do-conama-sobre-emissao-de-asv-uas-e-cai/'
        },
      ],
    },
    esg: {
      title: 'Responsabilidad Social y Ambiental',
      text: 'Fundada en 2020, ECOFAB cuenta con equipos multidisciplinarios compuestos por gestores, economistas, ingenieros (mecánicos, computación, químicos, civil, seguridad laboral y eléctrico), arquitectos, diseñadores y consultores ambientales. Nuestro compromiso con ESG (Environmental, Social and Governance) se refleja en valores como compromiso, agilidad, integridad, innovación tecnológica, formación continua, ética, responsabilidad, sostenibilidad y valoración de la vida.',
      icons: ['Sostenible', 'ISO', 'Social', 'ESG'],
    },
    contact: {
      title: 'Contacto',
      placeholders: {
        name: 'Nombre',
        email: 'Correo electrónico',
        company: 'Empresa',
        message: 'Mensaje',
      },
      button: 'Enviar',
      successMessage: '¡Mensaje enviado con éxito!',
      errorMessage: 'Error al enviar el mensaje. Por favor, inténtelo de nuevo.',
    },
    footer: {
      quickLinks: 'Enlaces Rápidos',
      links: ['Soluciones', 'Cómo Funciona', 'Blog', 'Responsabilidad', 'Contacto'],
      contactTitle: 'Contacto ECOFAB',
      address: 'Rua Nakle Francisco 1115\nBairro - Centro\nCidade - Balneário de Piçarras\nEstado - SC\nTeléfono: (47) 9 3300-3006\nCorreo: contato@ecofab.com.br',
      downloads: ['Catálogo de Productos (PDF)', 'Ficha Técnica (PDF)'],
      socialTitle: 'Redes Sociales',
      credits: '© 2024 ECOFAB Equipos y Soluciones Sostenibles LTDA - Todos los derechos reservados.',
    },
  },
};

export default translations;
